import { useState, useEffect } from 'react';
import { getCurrentTheme, Theme } from 'styles/themes';

export const useTheme = (): Theme => {
    const [theme, setTheme] = useState<Theme>(getCurrentTheme());

    useEffect(() => {
        // Check if matchMedia is supported
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        
        const handleChange = () => {
            setTheme(getCurrentTheme());
        };

        // Use addEventListener if available, otherwise use deprecated addListener
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        } else if (mediaQuery.addListener) {
            mediaQuery.addListener(handleChange);
            return () => mediaQuery.removeListener(handleChange);
        }
    }, []);

    return theme;
};
